/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { CallbackHolder } from "abweb/utils/callback/CallbackHolder";
// import {ICallback1ArgRegistration} from "abweb/utils/callback/ICallback1ArgPredicateRegistration";

/**
 * Multi-cast event structure with one strongly typed argument.
 * For a class to implement an event broadcaster.
 */
export class Callback1ArgPredicate extends CallbackHolder {
  /**
   * @returns {boolean} returns false iff any listener predicate returns false.
   * Invokes all listener predicates (does NOT short-circuit)
   */
  callAll(x) {
    let ret = true;
    for (let predicate of this.getCallbacks()) {
      ret = predicate(x) && ret;
    }
    return ret;
  }

  /**
   * @return {boolean} true iff any listener predicate returns true.  Short-circuits on first true,
   * and if there are no listener predicates at all it returns false.
   */
  callUntilFirstTrue(x) {
    for (let predicate of this.getCallbacks()) {
      if (predicate(x)) {
        return true;
      }
    }
    return false;
  }

  /**
   * @return {boolean} false iff any listener predicate returns false.  Short-circuits on first false,
   * and if there are no listener predicates at all it returns true.
   */
  callUntilFirstFalse(x) {
    for (let predicate of this.getCallbacks()) {
      if (!predicate(x)) {
        return false;
      }
    }
    return true;
  }
}
//# sourceMappingURL=Callback1ArgPredicate.js.map
